import React from "react";
import MessageListItem from "./MessageListItem";
import SortBy from "../utiles/SortBy";

const MessagesList = ({ messages, selectedMessageId, onSelectMessage, title, onNewMessage, onSortChange, onDelete }) => {
  const sortOptions = ["Name (A-Z)", "Date", "File Size"];

  return (
    <div className="flex flex-col h-full bg-gray2">
      {/* Header with title and sort */}
      <div className="bg-white mobile:bg-gray4 p-4 mobile:py-2 border-b flex items-center mobile:justify-between justify-end">
        {/* Desktop - Show Title */}
        <h3 className="text-black text-bodyMM font-normal hidden">{title}</h3>
        
        {/* Mobile - Show New Message Button */}
          <button className="flex items-center gap-2 text-gray5 text-bodyESR hover:text-primary">
            <SortBy
              items={sortOptions}
              onSortChange={onSortChange}/>
          </button>
          <button 
            className="md:hidden flex items-center gap-2 bg-primary text-white px-4 py-2 rounded-lg text-bodyMR hover:bg-orange-600 transition-colors"
            onClick={onNewMessage}
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd"
                d="M9 0.75C9.19891 0.75 9.38968 0.829018 9.53033 0.96967C9.67098 1.11032 9.75 1.30109 9.75 1.5V8.25H16.5C16.6989 8.25 16.8897 8.32902 17.0303 8.46967C17.171 8.61032 17.25 8.80109 17.25 9C17.25 9.19891 17.171 9.38968 17.0303 9.53033C16.8897 9.67098 16.6989 9.75 16.5 9.75H9.75V16.5C9.75 16.6989 9.67098 16.8897 9.53033 17.0303C9.38968 17.171 9.19891 17.25 9 17.25C8.80109 17.25 8.61032 17.171 8.46967 17.0303C8.32902 16.8897 8.25 16.6989 8.25 16.5V9.75H1.5C1.30109 9.75 1.11032 9.67098 0.96967 9.53033C0.829018 9.38968 0.75 9.19891 0.75 9C0.75 8.80109 0.829018 8.61032 0.96967 8.46967C1.11032 8.32902 1.30109 8.25 1.5 8.25H8.25V1.5C8.25 1.30109 8.32902 1.11032 8.46967 0.96967C8.61032 0.829018 8.80109 0.75 9 0.75Z"
                fill="white"/>
            </svg>
            New message
          </button>
      </div>

      {/* Messages List */}
      <div className="flex-1 overflow-y-auto bg-white">
        {messages.length === 0 ? (
          <div className="flex items-center justify-center h-full text-dark5 text-bodyMR">
            No messages found
          </div>
        ) : (
          <div className="space-y-1 p-2 overflow-y-auto">
            {messages.map((messages) => (
              <MessageListItem
                key={messages.id}
                messages={messages}
                isSelected={selectedMessageId === messages.id}
                onClick={onSelectMessage}
                onDelete={onDelete}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MessagesList;